import React from 'react';
import i18next from 'i18next';
import { FlexContainer, Title, Quantity } from '../../../styles/styled-components/Customer/Customer';
import { KitStatus } from '../../../models/customerOverview';

type StatusOverviewDialProps = {
  quantity: number | string;
  title: string;
  color: string;
  kitStatus: KitStatus;
  onClick: () => void;
};

export class StatusOverviewDial extends React.PureComponent<StatusOverviewDialProps> {
  render() {
    const { quantity, title, color } = this.props;

    return (
      <FlexContainer className={`StatusOverviewDial id-${this.props.kitStatus}`} style={{ color }} onClick={this.props.onClick}>
        <Quantity>{quantity}</Quantity>
        <Title>{i18next.t(title)}</Title>
      </FlexContainer>
    );
  }
}